<div class="flex flex-col gap-5">
    <!-- Header -->
    <h5 [@first] class="text-zen font-medium text-3xl">
        {{ "txtIntegration" | translate: language:ModuleNames.Common }}
    </h5>

    <!-- Integration Cards -->
    <div class="flex flex-row flex-wrap my-8 py-5">
        <!-- Thomas International -->
        <div class="p-7 mb-2 rounded-md group hover:bg-white hover:shadow-md transition-all 2xl:w-1/3 w-1/2 cursor-pointer"
            (click)="onOpenThomasIntegration()">
            <div class="flex flex-row gap-5 items-center">
                <img [@child3]
                    class="h-20 w-20 block rounded bg-white shadow group-hover:shadow-none object-center object-none transition-all"
                    src="assets/img/svg/thomas.svg" alt="" />
                <div>
                    <h5 [@child4] class="text-xl font-bold text-zen">
                        {{ "Thomas International" | translate: language:ModuleNames.Common }}
                    </h5>
                    <h5 [@child5] class="text-xxs font-normal text-zen mt-1">
                        {{ "TALENT ASSESSMENT" | translate: language:ModuleNames.Common }}
                    </h5>
                </div>
            </div>
            <p [@child6] class="text-xs text-zen my-5">
                {{ "Harness the power of psychology and machine learning with the Thomas talent assessment platform.
                Make smarter recruitment and development decisions." | translate: language:ModuleNames.Common }}
            </p>
            <div class="flex flex-row justify-end" *ngIf="tenant?.thomasIntegrated">
                <p [@child4] class="text-zen-green text-xs font-medium">
                    <i class="fal fa-check-circle"></i>
                    {{ "Integrated" | translate: language:ModuleNames.Common }}
                </p>
            </div>
        </div>

        <!-- Excel Integration -->
        <div class="p-7 mb-2 rounded-md group hover:bg-white hover:shadow-md transition-all 2xl:w-1/3 w-1/2 cursor-pointer"
            (click)="onOpenExcelIntegration()">
            <div class="flex flex-row gap-5 items-center">
                <img [@child3]
                    class="h-20 w-20 block rounded bg-white shadow group-hover:shadow-none object-center object-none transition-all"
                    src="assets/img/excel.png" alt="" style="object-fit: cover" />
                <div>
                    <h5 [@child4] class="text-xl font-bold text-zen">
                        {{ "Excel Integration" | translate: language:ModuleNames.Common }}
                    </h5>
                    <h5 [@child5] class="text-xxs font-normal text-zen mt-1">
                        Zenithr
                    </h5>
                </div>
            </div>
            <p [@child6] class="text-xs text-zen my-5">
                {{ "Harness the simplicity of integrating your data using Microsoft Excel" | translate:
                language:ModuleNames.Common }}
            </p>
            <div class="flex flex-row justify-end" *ngIf="selectedEntity?.DataIntegrated">
                <p [@child4] class="text-zen-green text-xs font-medium">
                    <i class="fal fa-check-circle"></i>
                    {{ "Integrated" | translate: language:ModuleNames.Common }}
                </p>
            </div>
        </div>
    </div>
</div>